import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { t } from '@lingui/core/macro'

import { useAccount } from './useAccount'
import { showToast } from '../utils/toast'
import { decodeJWT } from './useAccount'

export const useLogin = () => {
  const { pathname, search } = useLocation()
  const navigate = useNavigate()
  const { setIsLogining, setAuthToken, setUserId, setIsNewUser } = useAccount()

  useEffect(() => {
    const replacedSearch = search.replace(/\?/g, '&').replace('&', '?')
    const searchParams = new URLSearchParams(replacedSearch)
    // New flow: handle auth=success and store jwt_token from cookie
    if (searchParams.get('new_user')) {
      setIsNewUser(searchParams.get('new_user') === 'true')
    }
    if (searchParams.get('auth') === 'success') {
      setIsLogining(true)
      // Read jwt_token from cookie
      console.log('cookie: ', document.cookie)
      const cookies = document.cookie.split('; ')
      const jwtCookie = cookies.find((cookie) => cookie.trim().startsWith('jwt_token='))
      if (jwtCookie) {
        const jwtToken = jwtCookie.split('=')[1]
        const { userId } = decodeJWT(jwtToken)
        setAuthToken(jwtToken)
        setUserId(userId)
      }
      setIsLogining(false)
    } else if (!!searchParams.get('error')) {
      const error = searchParams.get('error')
      showToast.error(t`Login failed: ${error}`)
    }

    // Create a new URLSearchParams without the Steam params
    const newParams = new URLSearchParams()
    searchParams.forEach((value, key) => {
      // Only keep non-Steam params
      if (key !== 'auth' && key !== 'error' && key !== 'new_user') {
        newParams.append(key, value)
      }
    })

    // Clean up the URL by removing the Steam params
    const queryString = newParams.toString()
    const newPath = pathname + (queryString ? `?${queryString}` : '')
    navigate(newPath, { replace: true })
  }, [search, setAuthToken, setIsLogining, setIsNewUser, setUserId, navigate, pathname])
}
